import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiSupportUnreadCountGet } from '@/entities/support-chat/modules/api/supportChat';

// Pure WebSocket-driven: the initial mount fetches once, then
// `useAdminInboxSocket` invalidates this query on every `chat.inbox` event.
// No polling, no focus/reconnect refetch — the socket is the only update path.
export const useSupportUnreadCount = (enabled = true) =>
  useQuery({
    queryKey: queryKeys.supportChat.unreadCount,
    queryFn: apiSupportUnreadCountGet,
    enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
